import { useEffect, useState } from 'react';

// Shared breakpoint constant for consistency across the app
export const DESKTOP_BREAKPOINT = 768;

export const useIsDesktop = (breakpoint: number = DESKTOP_BREAKPOINT) => {
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= breakpoint : false,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= breakpoint);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [breakpoint]);

  return isDesktop;
};
